<template>
  <!--
    作者：luoyiming
    时间：2020-06-04
    描述：插件中心-雀豆商城-商品设置-编辑商品-其它
  -->
  <div>
    <div class="common-form">其它</div>
    <el-form-item label="限购数量" prop="limit_num" :rules="[{ required: true, message: '请填写限购数量' }]">
      <el-input type="number" v-model="form.limit_num" class="max-w460"></el-input>
    </el-form-item>


    <el-form-item label="是否特殊商品：" prop="is_special_goods" :rules="[{ required: true, message: '请选择是否是特殊商品' }]">
      <el-radio-group v-model="form.is_special_goods">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
      <div class="gray9">首充或赠送礼品选择是</div>
    </el-form-item>

  </div>
</template>

<script>
export default {
  inject: ['form']
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/activity/point/part/Other.vue